export enum DiplomaSeekingPath {
  BOTH = 'both',
  DIPLOMA_SEEKING = 'diploma_seeking',
  NON_DIPLOMA_SEEKING = 'non_diploma_seeking',
}
